import React from 'react';

type PropsType = {
    primerError: string;
};

import s from './primerError.scss';

/**
 * Error component for all primer methods
 */
export const PrimerError = ({primerError}: PropsType) => {
    if (!primerError) return null;

    return (
        <p className={s.error} id="error">
            {primerError}
        </p>
    );
};
